(function () {
  'use strict';

  document.querySelectorAll('[data-sano-creatine-product]').forEach(function (root) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var gallery = root.querySelector('[data-sano-creatine-gallery]');
    var galleryButtons = Array.from(root.querySelectorAll('[data-creatine-gallery-go]'));
    var galleryMedia = Array.from(root.querySelectorAll('[data-creatine-media]'));
    var galleryIndex = 0;
    var touchStartX = 0;

    function showMedia(index) {
      if (!galleryMedia.length) return;
      galleryIndex = (index + galleryMedia.length) % galleryMedia.length;
      galleryButtons.forEach(function (item, itemIndex) {
        var selected = itemIndex === galleryIndex;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      galleryMedia.forEach(function (item, itemIndex) {
        item.classList.toggle('is-hidden', itemIndex !== galleryIndex);
        if (itemIndex === galleryIndex && !reduceMotion) {
          item.classList.remove('is-switching');
          void item.offsetWidth;
          item.classList.add('is-switching');
        }
      });
    }

    galleryButtons.forEach(function (button, index) {
      button.addEventListener('click', function () { showMedia(index); });
    });
    if (gallery) {
      gallery.addEventListener('touchstart', function (event) {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });
      gallery.addEventListener('touchend', function (event) {
        var distance = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(distance) >= 45) showMedia(galleryIndex + (distance < 0 ? 1 : -1));
      }, { passive: true });
    }

    var quantity = root.querySelector('.sano-creatine__quantity input');
    var minus = root.querySelector('[data-creatine-quantity-minus]');
    var plus = root.querySelector('[data-creatine-quantity-plus]');
    if (quantity && minus && plus) {
      minus.addEventListener('click', function () {
        quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
      });
      plus.addEventListener('click', function () {
        quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
      });
    }

    var productForm = root.querySelector('[data-sano-creatine-form]');
    if (productForm && productForm.dataset.sanoAtcBound !== 'true') {
      productForm.dataset.sanoAtcBound = 'true';
      productForm.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (productForm.dataset.sanoAtcPending === 'true') return;

        var submitButton = productForm.querySelector('[type="submit"]');
        var variantInput = productForm.querySelector('[name="id"]');
        var quantityInput = productForm.querySelector('[name="quantity"]');
        var variantId = Number(variantInput && variantInput.value);
        var requestedQuantity = Math.max(1, Number(quantityInput && quantityInput.value || 1));
        if (!variantId) return;

        productForm.dataset.sanoAtcPending = 'true';
        if (submitButton) {
          submitButton.dataset.originalLabel = submitButton.textContent.trim();
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
          submitButton.querySelector('.btn__text').textContent = 'TOEVOEGEN…';
        }

        var rootRoute = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        fetch(rootRoute + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: requestedQuantity }] })
        }).then(function (response) {
          if (!response.ok) return response.json().then(function (payload) {
            throw new Error(payload.description || payload.message || 'Toevoegen mislukt.');
          });
          return response.json();
        }).then(function (payload) {
          var lineItem = payload.items && payload.items[0] || payload;
          document.dispatchEvent(new CustomEvent('sano:cart-item-added', {
            detail: { lineItem: lineItem, source: 'creatine-atc' }
          }));
          return fetch(rootRoute + 'cart.js', { headers: { 'Accept': 'application/json' } });
        }).then(function (response) {
          if (!response.ok) throw new Error('Winkelwagen kon niet worden geladen.');
          return response.json();
        }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          if (window.SanoCartResolver) {
            window.SanoCartResolver.open({ cart: cart, trigger: submitButton, source: 'creatine-atc' });
          }
        }).catch(function (error) {
          var message = productForm.querySelector('[data-sano-creatine-atc-error]');
          if (!message) {
            message = document.createElement('p');
            message.dataset.sanoCreatineAtcError = '';
            message.setAttribute('role', 'alert');
            productForm.appendChild(message);
          }
          message.textContent = error.message;
        }).finally(function () {
          productForm.dataset.sanoAtcPending = 'false';
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
            submitButton.querySelector('.btn__text').textContent = submitButton.dataset.originalLabel || 'WINKELWAGEN';
          }
        });
      }, true);
    }

    root.querySelectorAll('[data-creatine-dialog-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        var dialog = root.querySelector('[data-creatine-dialog="' + button.dataset.creatineDialogOpen + '"]');
        if (!dialog) return;
        dialog.hidden = false;
        document.body.style.overflow = 'hidden';
        var close = dialog.querySelector('.sano-creatine__dialog-close');
        if (close) close.focus();
      });
    });
    root.querySelectorAll('[data-creatine-dialog-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        var dialog = button.closest('[data-creatine-dialog]');
        if (dialog) dialog.hidden = true;
        document.body.style.removeProperty('overflow');
      });
    });
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var dialog = root.querySelector('[data-creatine-dialog]:not([hidden])');
      if (dialog) dialog.hidden = true;
      document.body.style.removeProperty('overflow');
    });

    var share = root.querySelector('[data-creatine-share]');
    if (share) share.addEventListener('click', function () {
      var payload = { title: share.dataset.shareTitle, url: share.dataset.shareUrl };
      if (navigator.share) navigator.share(payload).catch(function () {});
      else if (navigator.clipboard) navigator.clipboard.writeText(payload.url).catch(function () {});
    });

    if (!reduceMotion) {
      root.classList.add('is-motion-ready');
      window.requestAnimationFrame(function () { root.classList.add('is-ready'); });
      var revealNodes = root.querySelectorAll('[data-creatine-reveal]');
      if ('IntersectionObserver' in window) {
        var revealObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        }, { threshold: 0.14 });
        revealNodes.forEach(function (node) {
          node.classList.add('is-motion-ready');
          revealObserver.observe(node);
        });
      } else revealNodes.forEach(function (node) { node.classList.add('is-visible'); });
    }

    var price = root.querySelector('[data-creatine-price]');
    var priceCurrent = root.querySelector('[data-creatine-price-current]');
    var discountBar = root.querySelector('[data-creatine-discount-bar]');

    function formatCents(cents) {
      return new Intl.NumberFormat('nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    }

    function settleEntrance() {
      root.classList.add('is-creatine-sequence-complete');
      if (priceCurrent && price) priceCurrent.textContent = formatCents(Number(price.dataset.salePriceCents));
    }

    if (reduceMotion) {
      settleEntrance();
    } else if (price && priceCurrent && price.dataset.priceAnimated !== 'true') {
      var sale = Number(price.dataset.salePriceCents);
      var compare = Number(price.dataset.comparePriceCents);
      if (Number.isFinite(sale) && Number.isFinite(compare) && compare > sale) {
        price.dataset.priceAnimated = 'true';
        root.classList.add('is-creatine-sequence-ready');
        priceCurrent.textContent = formatCents(compare);

        window.setTimeout(function () {
          price.classList.add('is-price-counting');
          var startedAt = null;
          var duration = 900;

          function tick(timestamp) {
            if (startedAt === null) startedAt = timestamp;
            var progress = Math.min((timestamp - startedAt) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            priceCurrent.textContent = formatCents(Math.round(compare + ((sale - compare) * eased)));

            if (progress < 1) {
              window.requestAnimationFrame(tick);
              return;
            }

            priceCurrent.textContent = formatCents(sale);
            price.classList.remove('is-price-counting');
            price.classList.add('is-price-counted');
          }

          window.requestAnimationFrame(tick);
        }, 800);

        window.setTimeout(function () {
          if (discountBar) discountBar.classList.add('is-visible');
        }, 1020);

        window.setTimeout(settleEntrance, 1800);
      } else settleEntrance();
    } else settleEntrance();
  });
})();
